import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ArrowRight, CheckCircle2 } from "lucide-react";
import { OW_API, formatApiErrorDetail } from "../lib/operatorWalk";
import PortalAuthShell from "../components/ow/PortalAuthShell";

export default function PortalForgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${OW_API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalAuthShell
      title="Reset your password"
      subtitle="Enter your email and we will send you a link to set a new password."
      footer={
        <Link to="/portal/login" className="text-brand-700 underline" data-testid="portal-back-login-link">
          Back to login
        </Link>
      }
    >
      {sent ? (
        <div className="text-center" data-testid="portal-forgot-sent">
          <CheckCircle2 className="w-10 h-10 text-brand-500 mx-auto" />
          <p className="mt-4 text-ink-soft text-sm leading-relaxed">
            If that email is on file, a reset link is on its way. The link expires in one hour.
          </p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="portal-forgot-form">
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-ink-muted">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full border border-brand-200 px-4 py-3 text-sm focus:outline-none focus:border-brand-500"
              data-testid="portal-forgot-email"
              autoComplete="email"
            />
          </div>
          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2" data-testid="portal-forgot-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-brand-700 hover:bg-brand-800 text-white px-6 py-3.5 text-sm font-medium transition-colors disabled:opacity-60"
            data-testid="portal-forgot-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />}
            Send reset link
          </button>
        </form>
      )}
    </PortalAuthShell>
  );
}
